import { Roles } from '~/data/user';
import { fetchFromNewApi } from '~/services/Http';

export interface Performance {
  score: number;
  reviewDate: string;
}

export const getPerformanceHistory = async () => {
  return await fetchFromNewApi('/performanceHistory', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((r) => r.json());
};

export enum WorkspaceType {
  Company = 'company',
  Personal = 'personal',
  Default = 'default',
}

export enum WorkspaceUserGroup {
  Employee = 'employee',
  Manager = 'manager',
  DeputyManager = 'deputyManager',
  AlternateManager = 'alternateManager',
  HrAdmin = 'hrAdmin',
  HrStaff = 'hrStaff',
}

export const getWorkspaceUserGroup = (
  role: Roles | string,
): WorkspaceUserGroup => {
  switch (role) {
    case Roles.MANAGER:
      return WorkspaceUserGroup.Manager;
    case Roles.ALT_MANAGER:
      return WorkspaceUserGroup.AlternateManager;
    case Roles.DEPUTY_MANAGER:
      return WorkspaceUserGroup.DeputyManager;
    case Roles.HR_ADMIN:
      return WorkspaceUserGroup.HrAdmin;
    case Roles.HR_STAFF:
      return WorkspaceUserGroup.HrStaff;
    default:
      return WorkspaceUserGroup.Employee;
  }
};

export const getWorkspaceTypeTranslationKey = (
  type?: WorkspaceType | string,
): string => {
  return type === WorkspaceType.Company
    ? 'workspaceType_Company'
    : 'workspaceType_Personal';
};

export const getWorkspaceUserGroupTranslationKey = (
  userGroup?: WorkspaceUserGroup | string,
) => {
  const translationKeys: { [key in WorkspaceUserGroup]: string } = {
    [WorkspaceUserGroup.Manager]: 'laManager',
    [WorkspaceUserGroup.AlternateManager]: 'laAltManager',
    [WorkspaceUserGroup.DeputyManager]: 'laDeputyManager',
    [WorkspaceUserGroup.HrAdmin]: 'laHRAdmin',
    [WorkspaceUserGroup.HrStaff]: 'laHR',
    [WorkspaceUserGroup.Employee]: 'laEmployee',
  };

  return !!userGroup &&
    (Object.values(WorkspaceUserGroup) as string[]).includes(userGroup)
    ? translationKeys[userGroup as WorkspaceUserGroup]
    : translationKeys[WorkspaceUserGroup.Employee];
};
